import gql from 'graphql-tag'
import assign from 'lodash/assign'
import clone from 'lodash/clone'
import base from 'app/queries/base'

export default {

    all: function(options={}){

        return assign(clone(base), {

            query: gql`
                query AllRepairs($offset: Int, $limit: Int, $filter: RepairFilter, $sortField: RepairSortField, $sortDirection: SortDirection) {
                    viewer {
                        allRepairs(offset: $offset, limit: $limit, filter: $filter, sortField: $sortField, sortDirection: $sortDirection) {
                            totalCount
                            items {
                                id
                                reference
                                startDate
                                endDate
                                loggers {
                                    itemCount
                                }
                                createdAt
                                updatedAt
                            }
                        }
                    }
                }`,

            variables(){

                return {

                    offset: null,
                    limit: null,
                    filter: {},
                    sortField: 'startDate',
                    sortDirection: 'ASC'
                }
            },

            update: ({viewer}) => viewer.allRepairs

        }, options);
    },

    find: function(options={}){

        return assign(clone(base), {

            query: gql`
                query FindRepair($repairId: ID!, $loggersOffset: Int, $loggersLimit: Int, $loggersSortField: LoggerSortField, $loggersSortDirection: SortDirection) {
                    viewer {
                        findRepair(id: $repairId) {
                            id
                            reference
                            startDate
                            endDate
                            loggers(offset: $loggersOffset, limit: $loggersLimit, sortField: $loggersSortField, sortDirection: $loggersSortDirection) {
                                itemCount
                                items {
                                    id
                                    serialNumber
                                    state
                                    typeId
                                    type { 
                                        id
                                        title
                                    }
                                    owner
                                    comments
                                    latestMutation {
                                        id
                                        comments
                                    }
                                }
                            }
                            createdAt
                            updatedAt
                        }
                    }
                }`,

            update: ({viewer}) => viewer.findRepair

        }, options);
    }
}